import BossModel from "@/models/BossModel";
import User from "@/models/User/User";
import Customer from "@/models/Customer/Customer";
import UserGroup from "@/models/User/UserGroup/UserGroup";
import Message from "@/models/Message/Message";
import TaskAction from "@/models/Task/TaskAction/TaskAction";
import Dossier from "@/models/Dossier/Dossier";
import Schedule from "@/models/Task/Schedule/Schedule";
import {mutateDateTimeWithoutSeconds} from "@/utils/mutators";

export default class Task extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'task';

    /**
     *
     * @type {string}
     */
    static entity = 'tasks';

    static fields() {
		return {
			id: this.attr(null),
			name: this.attr(null),
			description: this.attr(null).nullable(),
			task_action_id: this.number(null).nullable(),
			dossier_id: this.number(null).nullable(),
			customer_id: this.number(null).nullable(),
			task_user_id: this.number(null).nullable(),
			check_user_id: this.number(null).nullable(),
			create_user_id: this.number(null).nullable(),
			is_completed: this.boolean(false),
			is_checked: this.boolean(false),
            is_expired: this.boolean(false),
			scheduled_at: this.attr(null),
            scheduled_by_user_id: this.attr(null),
			completed_at: this.attr(null),
			checked_at: this.attr(null),
			updated_at: this.attr(null),
			created_at: this.attr(null),
			user_group_id: this.number(null).nullable(),
			previous_user_id: this.number(null).nullable(),
            action: this.belongsTo(TaskAction, 'task_action_id'),
            dossier: this.belongsTo(Dossier, 'dossier_id'),
            customer: this.belongsTo(Customer, 'customer_id'),
            userGroup: this.belongsTo(UserGroup, 'user_group_id'),
            messages: this.hasMany(Message, 'task_id'),
            userCreated: this.belongsTo(User, 'create_user_id'),
            user: this.belongsTo(User, 'task_user_id'),
            scheduledByUser: this.belongsTo(User, 'scheduled_by_user_id'),
            schedules: this.hasMany(Schedule, 'schedules'),
		}
	}

    static mutators () {
        return {
            scheduled_at: mutateDateTimeWithoutSeconds,
        }
    }

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static loadByDossier(dossierId){
        return this.api()
            .where('dossier_id', dossierId)
            .limit(0)
            .with(['action', 'messages','schedules'])
            .get();
    }

    static counts(state, userId = null, userGroupId = null, scheduledBefore = null) {
        return this.api().action('count')
            .where('user_id', userId)
            .where('user_group_id', userGroupId)
            .where('scheduled_before', scheduledBefore)
            .where('state', state)
            .getSingle(false);
    }

    static isOpen(task) {
        return task.state === 1;
    }

    static isFinished(task) {
        return task.state === 2;
    }

    static isChecking(task) {
        return task.state === 3;
    }

    User() {
        return this.getRelated('user');
    }

    UserGroup() {
        return this.getRelated('userGroup');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    UserCreated(){
        return this.getRelated('userCreated');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    UserOrGroup(){
        if(this.task_user_id === null){
            return UserGroup.find(this.user_group_id);
        }
        return  User.find(this.task_user_id);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    TaskAction(){
        return this.getRelated('action');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Messages(){
        return this.getRelated('messages');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Dossier() {
        return this.getRelated('dossier');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Customer() {
        return this.getRelated('customer');
    }
}
